import { MP } from 'media-platform-js-sdk/dist/src/browser';
import { BASEPATH } from '../../constants';
import { MediaType } from '../../types/media';
import { joinPath } from '../../utils/path';
import {
  IUploadFileInfo,
  IUploadProgress,
  UploadErrorEvent,
  UploadJob,
  UploadProgressEvent,
  UploadSuccessEvent,
} from './types';

const UPLOAD_ROOT = window.__MP_UPLOAD_ROOT__ || '/';
const MEDIA_DOMAIN = window.__MP_MEDIA_DOMAIN__ || '';
const API_DOMAIN = window.__MP_API_DOMAIN__ || '';

const ONE_WEEK_AGE = 60 * 60 * 24 * 7;

const mediaPlatform = new MP.MediaPlatform({
  domain: API_DOMAIN,
  authenticationUrl: joinPath(BASEPATH, '/api/mp/auth'),
});

function uploadFile(
  fileInfo: IUploadFileInfo,
  file: File,
  handlers: {
    onProgress?(progress: IUploadProgress): void;
  },
): Promise<string> {
  return new Promise((resolve, reject) => {
    const request = new MP.file.UploadFileRequest({ age: ONE_WEEK_AGE });
    // @ts-expect-error
    const job: UploadJob = mediaPlatform.fileManager.uploadFile(
      fileInfo.path,
      file,
      request,
    );

    job.on('upload-progress', (event: UploadProgressEvent) => {
      if (handlers.onProgress) {
        handlers.onProgress({ total: event.total, loaded: event.loaded });
      }
    });
    job.on('upload-success', async (event: UploadSuccessEvent) => {
      resolve(getUploadedUrl(event.name));
    });
    job.on('upload-error', (error: UploadErrorEvent) => {
      reject(error.response);
    });
  });
}

function getMediaType(file: File): MediaType {
  return file.type.split('/')[0] === 'video'
    ? MediaType.VIDEO
    : MediaType.IMAGE;
}

function getUniqueName(file: File): string {
  return `${Date.now()}__${file.name}`;
}

function getUploadedPath(name: string): string {
  return UPLOAD_ROOT + name;
}

function getUploadedUrl(name: string): string {
  return 'https://' + MEDIA_DOMAIN + encodeURI(getUploadedPath(name));
}

function getFileInfo(file: File): IUploadFileInfo {
  const uniqueName = getUniqueName(file);
  return {
    originalName: file.name,
    name: uniqueName,
    path: getUploadedPath(uniqueName),
    url: getUploadedUrl(uniqueName),
    type: getMediaType(file),
  };
}

export {
  getFileInfo,
  getUniqueName,
  getUploadedPath,
  getUploadedUrl,
  uploadFile,
};
